import { atom, useAtom } from 'jotai'

export const isOpenEmployeeSearch = atom(false)

export const useIsOpenEmployeeSearch = () => {
    const [isOpen, setIsOpen] = useAtom(isOpenEmployeeSearch)

    return { isOpen, setIsOpen }
}
